import withTransientStyleProps from '../../../utils/withTransientStyleProps';
import TrackedLink from '../../TrackedLink';
import HubspotLogoIcon from '../../icons/HubspotLogo';
import SprocketIcon from '../../icons/Sprocket';
import styled, { css } from 'styled-components';
import { hsLogoContainerMaxWidth } from '../utils/logoContainerWidth';
import { isGlobalNavAcademyMode } from '../../../utils/navEnviro';
import { useAppSelector } from '../../../hooks';
import { ButtonWithDemoExitConfirmation } from '../../DemoExitConfirmation/ButtonWithDemoExitConfirmation';
import useHomePath from '../../../hooks/useHomePath';
import { navTheme } from '../../../theme/nav-theme';
import { selectHasGlobalHomeAccess } from '../../../selectors/nav-items.selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledLogoLink = styled(withTransientStyleProps(TrackedLink))(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["display:flex;padding:6px 8px !important;justify-content:center;align-items:center;width:auto;border-radius:6px;height:auto;&:hover{background:", ";}svg{width:25px !important;height:auto !important;display:flex;align-self:center;}"], navTheme(theme).navBgSecondary);
});
const StyledLogoContainer = styled.div.withConfig({
  displayName: "GlobalToolbarSprocket__StyledLogoContainer",
  componentId: "sc-13z2axe-0"
})(["display:flex;align-items:center;flex-shrink:0;width:100%;max-width:", ";margin:0 !important;"], ({
  verticalNavWidth
}) => hsLogoContainerMaxWidth(verticalNavWidth));
const StyledAcademyText = styled.span.withConfig({
  displayName: "GlobalToolbarSprocket__StyledAcademyText",
  componentId: "sc-13z2axe-1"
})(({
  isGridBreakpointSmall,
  theme: _theme
}) => {
  const theme = _theme;
  return css(["color:", " !important;opacity:0.5;font-size:", ";position:relative;left:", ";"], navTheme(theme).navTextSecondary, isGridBreakpointSmall ? '14px !important' : '18px !important', isGridBreakpointSmall ? '4px' : '8px');
});
const StyledHubspotLogoIconWrapper = styled.div.withConfig({
  displayName: "GlobalToolbarSprocket__StyledHubspotLogoIconWrapper",
  componentId: "sc-13z2axe-2"
})(["display:flex;padding:6px 8px !important;justify-content:center;align-items:center;width:auto;height:auto;"]);
const GlobalToolbarSprocketContent = ({
  isAcademyMode,
  isGridBreakpointSmall,
  isHubless,
  hasGlobalHomeAccess,
  homePath
}) => {
  if (isAcademyMode && isGridBreakpointSmall) {
    return /*#__PURE__*/_jsx(SprocketIcon, {
      title: "HubSpot"
    });
  }
  if (isHubless || hasGlobalHomeAccess) {
    return /*#__PURE__*/_jsx(StyledHubspotLogoIconWrapper, {
      children: /*#__PURE__*/_jsx(HubspotLogoIcon, {
        title: "HubSpot",
        style: {
          width: '25px',
          height: 'auto'
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(ButtonWithDemoExitConfirmation, {
    component: StyledLogoLink,
    "data-test-id": "home-link",
    href: homePath,
    id: "nav-home-link",
    children: /*#__PURE__*/_jsx(HubspotLogoIcon, {
      title: "HubSpot"
    })
  });
};
export const GlobalToolbarSprocket = ({
  isGridBreakpointSmall,
  isHubless
}) => {
  const isAcademyMode = isGlobalNavAcademyMode();
  const verticalNavWidth = useAppSelector(state => state.navLayoutDimensionsState.rootNav.VerticalNav.width);
  const homePath = useHomePath();
  const hasGlobaHomeAccess = useAppSelector(selectHasGlobalHomeAccess);
  return /*#__PURE__*/_jsxs(StyledLogoContainer, {
    isGridBreakpointSmall: isGridBreakpointSmall,
    verticalNavWidth: verticalNavWidth,
    children: [/*#__PURE__*/_jsx(GlobalToolbarSprocketContent, {
      isAcademyMode: isAcademyMode,
      isGridBreakpointSmall: isGridBreakpointSmall,
      isHubless: isHubless,
      hasGlobalHomeAccess: hasGlobaHomeAccess,
      homePath: homePath
    }), isAcademyMode ? /*#__PURE__*/_jsx(StyledAcademyText, {
      isGridBreakpointSmall: isGridBreakpointSmall,
      children: "Academy"
    }) : null]
  });
};